import React from 'react'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import { isExcelAssignment } from '../../../../utils/assignment.helper'
import ExcelAnswerTablesGroup from '../../../../components/common/excel-answer-table/ExcelAnswerTablesGroup'
import FileDrawerEditor from './FileDrawerEditor'
import { Spin } from 'antd'

const FileDrawerContent = () => {
    const drawer = useSelector(state => state.assignment.drawer)
    const language = useSelector(assignmentSelectors.language)
    const isWaitingForAssignmentInfo = useSelector(state => state.assignment.isWaitingForAssignmentInfo)
    const isWaitingForClusters = useSelector(state => state.assignment.isWaitingForClusters)

    return (
        <Spin spinning={isWaitingForAssignmentInfo || isWaitingForClusters} tip='Loading file...'>
            {isExcelAssignment(language) ? (
                <ExcelAnswerTablesGroup answers={drawer.file.content} />
            ) : (
                <FileDrawerEditor />
            )}
        </Spin>
    )
}

export default FileDrawerContent
